import { getRouters } from '@/api/index'
import Layout from '@/layout/index.vue'

const state = {
  routes: [],
  addRoutes: [],
  tabRoutes: [] // 专门存放底部导航的路由
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    // 将所有路由合并，确保非 tab 页面也能正常访问
    state.routes = routes 
  },
  SET_TAB_ROUTES: (state, routes) => {
    state.tabRoutes = routes
  }
}

const actions = {
  GenerateRoutes({ commit }) {
    return new Promise((resolve, reject) => {
      getRouters({mobileEnabled:1}).then(res => {
        let asyncRoutes = res.data.data || res
        
        if (!Array.isArray(asyncRoutes)) {
          reject(new Error('路由数据格式错误'))
          return
        }
        
        // 修改点：不再过滤 type === 'tab'，直接把所有一级路由作为底部导航
        const tabRoutes = asyncRoutes
        
        // 将所有路由包装进 Layout
        const accessedRoutes = wrapWithLayout(asyncRoutes)
        
        commit('SET_ROUTES', accessedRoutes)
        commit('SET_TAB_ROUTES', tabRoutes) // 提交所有一级路由
        
        resolve(accessedRoutes)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
// 包装路由的辅助函数
function wrapWithLayout(routes) {
  // 递归处理组件加载和子路由
  const processedRoutes = routes.map(route => {
    const routeCopy = { ...route }
    if (routeCopy.component) {
      routeCopy.component = loadView(routeCopy.component)
    }
    if (routeCopy.children) {
      routeCopy.children = processChildren(routeCopy.children)
    }
    return routeCopy
  })

  // 返回包裹了 Layout 的路由数组
  return [{
    path: '/',
    component: Layout,
    redirect: processedRoutes[0]?.path || '/login',
    children: processedRoutes
  }]
}

function processChildren(children) {
  if (!Array.isArray(children)) return []
  return children.map(child => {
    const childCopy = { ...child }
    if (childCopy.component) {
      childCopy.component = loadView(childCopy.component)
    }
    if (childCopy.children) {
      childCopy.children = processChildren(childCopy.children)
    }
    return childCopy
  })
}

// 动态加载组件
export const loadView = (view) => {
  if (process.env.NODE_ENV === 'development') {
    return (resolve) => require([`@/views/${view}`], resolve)
  } else {
    return () => import(`@/views/${view}`)
  }
}

export default {
  namespaced: true, // 确保开启了命名空间
  state,
  mutations,
  actions
}